/* globals FWP */

let scrollAfterPagination = false;

/**
 * Mark that the user triggered a FacetWP page change.
 *
 * @param {MouseEvent} event
 */
function handlePagerClick(event) {
	if (!event.target.closest('.facetwp-type-pager .facetwp-page')) {
		return;
	}

	scrollAfterPagination = true;
}

/**
 * Space occupied by the sticky header from the top of the viewport.
 * Uses theme CSS vars (same as main padding) and the measured header bottom.
 *
 * @return {number}
 */
function getStickyHeaderOffset() {
	const rootStyles = getComputedStyle(document.documentElement);
	const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
	const cssHeaderHeight =
		parseFloat(rootStyles.getPropertyValue(isDesktop ? '--strl-header-height' : '--strl-m-header-height')) || 0;

	let adminBarHeight = 0;
	if (document.body.classList.contains('admin-bar')) {
		adminBarHeight = parseFloat(rootStyles.getPropertyValue('--wp-admin--admin-bar--height')) || 0;
	}

	const header = document.querySelector('#site-header');
	const measured = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;

	return Math.ceil(Math.max(cssHeaderHeight + adminBarHeight, measured));
}

/**
 * Align .fwp-scroll-target flush under the sticky header (pagination only).
 */
function scrollToFacetTarget() {
	if (!scrollAfterPagination) {
		return;
	}

	scrollAfterPagination = false;

	const target = document.querySelector('.fwp-scroll-target');
	if (!target) {
		return;
	}

	const run = () => {
		const offset = getStickyHeaderOffset();
		target.style.scrollMarginTop = `${offset}px`;
		target.scrollIntoView({
			block: 'start',
			behavior: 'instant',
		});
	};

	// FacetWP may apply its own scroll on the same tick — run after layout, then re-assert.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			run();
			setTimeout(run, 50);
		});
	});
}

/**
 * Toggle .filter-current visibility based on active FacetWP facets/selections.
 */
function handleFilterCurrent() {
	const filterCurrentElements = document.querySelectorAll('.filter-current');

	filterCurrentElements.forEach((filterCurrent) => {
		const hasActiveFilters =
			FWP.facets &&
			Object.keys(FWP.facets).some((facetName) => {
				const facet = FWP.facets[facetName];
				return facet && facet.length > 0;
			});

		const selections = document.querySelectorAll('.facetwp-selections .facetwp-selection-value');
		const hasSelections = selections.length > 0;

		if (!hasActiveFilters && !hasSelections) {
			filterCurrent.style.display = 'none';
		} else {
			filterCurrent.style.display = 'flex';
		}
	});
}

document.addEventListener('click', handlePagerClick);
document.addEventListener('facetwp-loaded', () => {
	handleFilterCurrent();
	scrollToFacetTarget();
});
